import { createFileRoute } from "@tanstack/react-router";
import TermsOfUsePage from "@/site/pages/terms";

export const Route = createFileRoute("/terms")({
  component: TermsOfUsePage,
});
